module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "wrap"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-77159c7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/regexp-replace-loader?{"match":{"pattern":"replacing_version","flags":"g"},"replaceWith":"1.0.8"}!./src/commponents/toast/toast.vue
// module id = 1fCB
// module chunks = 5